<!-- Content -->
<div>
	<!-- Success Message -->
	<div *ngIf="success" class="mb-4 p-4 bg-green-50 border border-green-200 rounded-md">
		<div class="flex items-center">
			<svg class="w-5 h-5 text-green-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
				<path fill-rule="evenodd"
					d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
					clip-rule="evenodd"></path>
			</svg>
			<span class="text-green-800 font-medium">Compte mis à niveau avec succès !</span>
		</div>
		<p class="text-green-700 text-sm mt-1">Le compte a été converti en compte principal.</p>
	</div>



	<!-- Form -->
	<form [formGroup]="upgradeForm" *ngIf="!success" (ngSubmit)="onSubmit()" class="space-y-4">
		<div>
			<label for="phoneNumber" class="block text-sm font-medium text-gray-700 mb-2">
				Renseignez le numéro de téléphone qui sera rattaché au passeport
			</label>
			<angular-phone-number-input [preferredCountries]="preferredCountries" [defaultCountry]="'SN'" [border]="true"
				formControlName="phoneNumber" (phoneNumberChange)="onPhoneNumberChange($event)"
				class="w-full h-[55px] rounded placeholder:text-gray-500 text-gray-700 bg-white"
				[ariaPlaceholder]="'Numéro de téléphone'" placeholder="Numéro de téléphone">
			</angular-phone-number-input>
			<div *ngIf="phoneNumberError" class="text-red-500 text-xs mt-1 ml-2">
				{{ phoneNumberError }}
			</div>
		</div>

		<div>
			<label for="email" class="block text-sm font-medium text-gray-700 mb-2">
				Renseignez l'email qui sera rattaché au passeport
			</label>
			<input type="email" id="email" formControlName="email"
				class="w-full h-[55px] px-3 py-2 border border-gray-300 rounded-md placeholder:text-gray-500 text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
				placeholder="Adresse email">
			<div *ngIf="emailError" class="text-red-500 text-xs mt-1 ml-2">
				{{ emailError }}
			</div>
		</div>

		<!-- Warning -->
		<!-- <div class="p-4 bg-yellow-50 border border-yellow-200 rounded-md">
			<div class="flex items-start">
				<svg class="w-5 h-5 text-yellow-400 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
					<path fill-rule="evenodd"
						d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
						clip-rule="evenodd"></path>
				</svg>
				<div>
					<h4 class="text-sm font-medium text-yellow-800">Attention</h4>
					<p class="text-sm text-yellow-700 mt-1">
						Cette action convertira définitivement ce sous-compte en compte principal.
						Le compte aura accès à toutes les fonctionnalités d'un compte principal.
					</p>
				</div>
			</div>
		</div> -->
	</form>
</div>

<!-- Footer -->
<div class="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
	<button type="button" (click)="closeModal()"
		class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
		[disabled]="loading">
		Annuler
	</button>
	<button type="submit" (click)="onSubmit()"
		class="px-4 py-2 text-sm font-medium text-white bg-primary border border-transparent rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed"
		[disabled]="loading || !upgradeForm.get('phoneNumber')?.value?.trim()">
		<span *ngIf="!loading">Valider</span>
		<span *ngIf="loading" class="flex items-center">
			<svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
				<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
				<path class="opacity-75" fill="currentColor"
					d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
				</path>
			</svg>
			Traitement en cours...
		</span>
	</button>
</div>